
import { Html5Qrcode } from "html5-qrcode";
import { dispatchScan } from '../features/scan.js';

let initialized = false;
let qr = null, last = "", lastAt = 0;

export function initScanner({ mode = 'back', ttl = 10_000 } = {}) {
    if (initialized) return;
    initialized = true;

    if (window.EBWeb) {
        const m = document.createElement('script');
        m.src = "/build/assets/ebapi-modules.zebra.eb.js";
        m.onload = () => {
            const e = document.createElement('script');
            e.src = "/build/assets/elements.zebra.eb.js";
            e.onload = () => { if (typeof EB !== "undefined") window.EBScannerInit?.(); };
            document.body.appendChild(e);

            window.EBScannerInit = function () {
                document.querySelector('.checkin-scanner .eb-message')?.classList.add('show');
                if (!window.EB?.Barcode) return;
                EB.Barcode.illuminationMode = 'alwaysOff';
                EB.Barcode.enable({}, (params) => {
                    document.body.classList.add('fetching');
                    const data = params?.data || "";
                    if (!data) { alert('Scan timeout'); return; }
                    dispatchScan({ data });
                });
            };

        };
        document.body.appendChild(m);
        return { pause() { }, resume() { } };
    } else {

        window.qrScannerInit = function (camera = "back", ttl = 1000) {
            document.querySelector('.checkin-scanner .scanner')?.classList.add('show');
            if (qr || !document.getElementById('qr-scanner')) return;

            qr = new Html5Qrcode('qr-scanner', {
                formatsToSupport: [0], verbose: true
            });

            const facingMode = camera === 'front' ? 'user' : 'environment';

            qr.start(
                { facingMode },
                { fps: 5, qrbox: { width: 250, height: 250 }, showTorchButtonIfSupported: true },
                (text) => {
                    const now = Date.now();

                    // Only block if it's the SAME text and within the cooldown window
                    if (text === last && (now - lastAt) < ttl) {
                        return; // ignore duplicate within TTL
                    }

                    // Accept this scan (either new text, or same text after TTL)
                    last = text;
                    lastAt = now;

                    document.body.classList.add('fetching');
                    dispatchScan({ data: text });
                },
                () => { /* optional: decode failure callback */ }
            )
                .then(() => console.log('QR ready'))
                .catch(console.error);
        };

        window.qrScannerPause = () => {
            if (qr && !qr.stateManagerProxy.isPaused()) {
                qr.pause(true);
            }
        };
        window.qrScannerResume = () => {
            lastAt = 0;
            if (qr && qr.stateManagerProxy.isPaused()) {
                qr.resume();
            }
        }; // allow immediate rescan on resume

        window.qrScannerInit?.(mode, ttl);

        return {
            pause() { window.qrScannerPause?.(); },
            resume() { window.qrScannerResume?.(); }
        };
    }

}
